/** Board preferences belong to a person and organization, never the whole browser. */
export function boardPreferenceKey(
  kind: 'jobs' | 'opportunities',
  user: { id: number; organization?: { id: string } | number | string } | null,
) {
  const organization =
    typeof user?.organization === 'object' ? user.organization?.id : user?.organization;
  return user?.id && organization ? `apexos:last-board:${kind}:${organization}:${user.id}` : null;
}

export function preferredBoard<T extends { id: number; is_default?: boolean }>(
  boards: T[],
  key: string | null,
): number | null {
  let saved: number | null = null;
  try {
    saved = key ? Number(localStorage.getItem(key)) : null;
  } catch {
    /* Storage can be unavailable in private browsing. */
  }
  return (
    boards.find((board) => board.id === saved)?.id ??
    boards.find((board) => board.is_default)?.id ??
    boards[0]?.id ??
    null
  );
}

export function rememberBoard(key: string | null, boardId: number) {
  try {
    if (key) localStorage.setItem(key, String(boardId));
  } catch {
    /* The board must still work without storage. */
  }
}
